import React, { useEffect } from 'react';
import { X, Download, BookOpen } from 'lucide-react';

export default function PdfViewerModal({ url, title, onClose }) {
  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        background: 'rgba(0,0,0,0.75)',
        display: 'flex', flexDirection: 'column',
        fontFamily: "'Inter', sans-serif",
      }}
    >
      {/* Header bar */}
      <div style={{
        background: '#17140F',
        display: 'flex', alignItems: 'center', gap: '0.75rem',
        padding: '0.7rem 1.25rem', flexShrink: 0,
        borderBottom: '1px solid rgba(255,255,255,0.08)',
      }}>
        <div style={{
          width: '30px', height: '30px', background: '#E8672E',
          borderRadius: '7px', display: 'flex', alignItems: 'center',
          justifyContent: 'center', flexShrink: 0,
        }}>
          <BookOpen size={15} color="white" />
        </div>

        <span style={{
          color: 'white', fontSize: '0.88rem', fontWeight: '700',
          flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
        }}>
          {title || 'Lecture Notes'}
        </span>

        <a
          href={url}
          download
          style={{
            display: 'inline-flex', alignItems: 'center', gap: '0.4rem',
            background: 'rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.75)',
            textDecoration: 'none', padding: '0.4rem 0.85rem', borderRadius: '7px',
            fontSize: '0.78rem', fontWeight: '600', flexShrink: 0,
          }}
          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.18)'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.1)'; }}
        >
          <Download size={13} /> Download
        </a>

        <button
          onClick={onClose}
          aria-label="Close PDF viewer"
          style={{
            background: 'rgba(255,255,255,0.08)', border: 'none',
            color: 'rgba(255,255,255,0.65)', cursor: 'pointer',
            borderRadius: '7px', padding: '0.4rem 0.5rem',
            display: 'flex', alignItems: 'center', flexShrink: 0,
          }}
          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.16)'; e.currentTarget.style.color = 'white'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.08)'; e.currentTarget.style.color = 'rgba(255,255,255,0.65)'; }}
        >
          <X size={18} />
        </button>
      </div>

      {/* PDF iframe — fills remaining height */}
      <iframe
        src={url}
        title={title || 'Lecture Notes'}
        style={{ flex: 1, border: 'none', display: 'block', background: '#525659' }}
      />
    </div>
  );
}
